/**
 * Calculates the age a user will be when their mortgage has ended
 *
 * @param {number} month Month number (within term)
 * @param {number} remainingBalance Remaining balance in pence
 * @param {number} monthlyPayment Monthly payment in pence
 * @param {number} overpaymentAmount Overpayment in pence
 * @param {string} overpaymentInterval Interval - 'monthly' || 'single'
 * @param {number} interestRate Interest rate as a float
 *
 * @return {number} Balance at month in pence
 *
 */

import getMonthlyInterestRate from './getMonthlyInterestRate';

const getBalanceAtMonth = (args) => {
  // Check arguments
  if (!args.month && args.month !== 0) throw new Error('Month is required');
  if (!args.remainingBalance && args.remainingBalance !== 0)
    throw new Error('Remaining balance is required');
  if (!args.monthlyPayment && args.monthlyPayment !== 0)
    throw new Error('Monthly payment is required');
  if (!args.interestRate && args.remainingBalance !== 0)
    throw new Error('Interest rate is required');

  const {
    month,
    remainingBalance,
    monthlyPayment,
    overpaymentAmount,
    overpaymentInterval,
    interestRate,
  } = args;

  // Calculate monthly interest rate
  const monthlyInterestRate = getMonthlyInterestRate(interestRate);

  // Calculate increase (e.g 103.92%)
  const increase = 1 + monthlyInterestRate;
  // Calculate total monthly payment
  const totalMonthlyPayment =
    overpaymentInterval === 'monthly'
      ? monthlyPayment + overpaymentAmount
      : monthlyPayment;

  const calculatedRemainingBalance =
    overpaymentInterval === 'single'
      ? remainingBalance - overpaymentAmount
      : remainingBalance;

  const balanceAtMonth =
    calculatedRemainingBalance * increase ** month -
    totalMonthlyPayment * ((increase ** month - 1) / monthlyInterestRate);

  return Math.ceil(balanceAtMonth);
};

export default getBalanceAtMonth;
